import React, { useState, useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';
import { useForm } from 'react-hook-form';
import { useDeepCompare } from 'hooks/use-deep-memo';
import SliderCustom from 'components/slider';
import CurrencyInput from 'components/custom-inputs/currency-input';
import { useDispatch } from 'react-redux';
import { setSIPlumsumCalculatorFormChanges } from '../investment-calculator.actions';


interface CalculatorFormProps {
    defaultValues: any,
    inputLabel: string,
    defaultAmountTabs?: number[],
    rules?: any,
}

const CalculatorForm: React.FC<CalculatorFormProps> = ({ defaultValues, inputLabel, defaultAmountTabs, rules }) => {

    const dispatch = useDispatch();
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const [calculatorValues, setCalculatorValues] = useState<any>(defaultValues);
    const printRef = React.useRef<HTMLDivElement>(null);
    const { errors, control, trigger, setValue } = useForm({ mode: 'all' });

    const onRateChange = (rate: any) => {
        setCalculatorValues({ ...calculatorValues, rateOfReturn: rate })
    }
    const onTimeChange = (timePeriod: any) => {
        setCalculatorValues({ ...calculatorValues, timePeriod: timePeriod })
    }
    const onAmountChange = (investmentAmt: any) => {
        if (investmentAmt >= rules?.min?.value && investmentAmt <= rules?.max?.value) { setCalculatorValues({ ...calculatorValues, investmentAmt: investmentAmt }) }
    }

    //@purpose - currencyinput can be changed from 3 sources:- change in amount/choosing an option/coming from link
    useEffect(() => {
        setCalculatorValues(defaultValues);
    }, [useDeepCompare(defaultValues)]);

    //@purpose- calculate gains with change in slider or amount
    useEffect(() => {
        dispatch(setSIPlumsumCalculatorFormChanges(calculatorValues));
        trigger('amount');
    }, [calculatorValues])


    return (
        <>
            <div>
                <div ref={printRef}>
                    <form name="calculatorForm">
                        <CurrencyInput
                            id="amount"
                            type="text"
                            name='amount'
                            variant='line'
                            defaultValue={defaultValues?.investmentAmt}
                            control={control}
                            errors={errors}
                            placeholder="Enter amount"
                            rules={rules}
                            fontSize={isMobile ? '16px' : '24px'}
                            setValue={setValue}
                            defaultAmounts={defaultAmountTabs}
                            handleChange={(value: number) => onAmountChange(value)}
                            inputLabel={<p className='font14 grey1 bold'>{inputLabel}</p>}
                        />
                        <SliderCustom
                            options={{
                                min: 1, max: 30,
                                handleSliderChange: onRateChange,
                                defaultValue: defaultValues?.rateOfReturn,
                                sliderLabel: 'Expected rate of return (yearly)', addOn: '%',
                                marks: {
                                    1: {
                                        style: {
                                            color: '#6C7375',
                                        },
                                        label: '1%',
                                    },
                                    30: {
                                        style: {
                                            color: '#6C7375',
                                            right: '0%',
                                            left: 'unset'
                                        },
                                        label: '30%',
                                    }
                                }
                            }} />
                        <div className='mt16'>
                            <SliderCustom
                                options={{
                                    min: 1, max: 30, handleSliderChange: onTimeChange,
                                    defaultValue: defaultValues?.timePeriod,
                                    sliderLabel: 'Time period', addOn: 'Yrs',
                                    marks: {
                                        1: {
                                            style: {
                                                color: '#6C7375',

                                            },
                                            label: '1 year',
                                        },
                                        30: {
                                            style: {
                                                color: '#6C7375',
                                                right: '0%',
                                                left: 'unset'
                                            },
                                            label: '30 years',
                                        }
                                    }
                                }} />
                        </div>
                    </form>
                </div>
            </div>
        </>
    )
}

export default CalculatorForm